import { ADD_PLAN_LOADING, ADD_PLAN_SUCCESS, ADD_PLAN_FAILED } from "../types";
import { Plan } from "../../models/Plan";

interface AddPlansuccess {
  plan: Plan | null;
  loading: boolean;
  error: string | null;
  success: boolean;
}

const initialsuccess: AddPlansuccess = {
  plan: null,
  loading: false,
  error: null,
  success: false,
};

type Action =
  | { type: typeof ADD_PLAN_LOADING; loading: boolean }
  | { type: typeof ADD_PLAN_SUCCESS; payload: Plan }
  | { type: typeof ADD_PLAN_FAILED; error: string };

export const createRecurringPlanReducer = (
  success = initialsuccess,
  action: Action
): AddPlansuccess => {
  switch (action.type) {
    case ADD_PLAN_LOADING:
      return {
        ...success,
        loading: action.loading,
        error: null,
        success: false,
      };

    case ADD_PLAN_SUCCESS:
      return {
        ...success,
        loading: false,
        plan: action.payload,
        error: null,
        success: true,
      };

    case ADD_PLAN_FAILED:
      return {
        ...success,
        loading: false,
        error: action.error,
        success: false,
      };

    default:
      return success;
  }
};
